import { Box, Paper, Button, CircularProgress } from "@mui/material";
import PasswordInput from "../PasswordInput";
import { useState } from "react";
import { updatePassword } from "../../services/auth";
import { enqueueSnackbar } from "notistack";

const PasswordUpdate = () => {

  const [ current_password, set_current_password ] = useState('');
  const [ new_password, set_new_password ] = useState('');
  const [ confirm_password, set_confirm_password ] = useState('');
  const [ is_saving, set_is_saving ] = useState(false);

  const handleSavePassword = async () => {
    
    if(new_password === confirm_password){
      set_is_saving(true);
      const {data} = await updatePassword({
        data : {
          current_password : current_password,
          new_password : new_password
        }
      })
      set_is_saving(false);

      if(data){
        if(data.success){
          enqueueSnackbar('Password updated successfully', {
            variant : 'success'
          })
          set_current_password('');
          set_new_password('');
          set_confirm_password('');
        }else{
          enqueueSnackbar('Invalid current password', {
            variant : 'error'
          })
        }
      }else{
        enqueueSnackbar('Error while updating password', {
          variant : 'error'
        })
      }
    }else{
      enqueueSnackbar('New Password and confirm password does not match !', {
        variant : 'warning'
      });
    }
  }

  return (
    <Paper
      elevation={4}
      sx={{
        padding: '20px',
        display : 'flex',
        gap : '20px',
        flexDirection : 'column'
      }}
    >

      <PasswordInput
        label="Current Password"
        value={current_password}
        onChange={(e) => set_current_password(e.target.value)}
      />

      <PasswordInput
        label="New Password"
        value={new_password}
        onChange={(e) => set_new_password(e.target.value)}
      />

      <PasswordInput
        label="Confirm New Password"
        value={confirm_password}
        onChange={(e) => set_confirm_password(e.target.value)}
      />

      <Box
        display='flex'
        justifyContent='flex-end'
      >
        <Button
          variant="contained"
          onClick={handleSavePassword}
          disabled = {
            is_saving ||
            !Boolean(current_password) ||
            !Boolean(new_password) ||
            !Boolean(confirm_password)
          }
        >
          {
            is_saving ? <CircularProgress size='20px' color="inherit" /> : 'Save'
          }
        </Button>
      </Box>
    </Paper>
  )
}

export default PasswordUpdate;